const t = {
  name: "UpliftProtect",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg>
      <path d="M21 2H16V0H23V7H21V2Z" fill="currentColor"/>
      <path d="M17 6H12V4H19V11H17V6Z" fill="currentColor"/>
      <path d="M19 11H21V14.29C21 16.9381 19.5066 19.3647 17.1272 20.5544L12 23.118L6.87103 20.5535C4.5062 19.3653 3 16.9514 3 14.29V2H12V4H5V14.29C5 16.1883 6.07343 17.9141 7.7681 18.766L12 20.882L16.2328 18.7656C17.9334 17.9153 19 16.1819 19 14.29V11Z" fill="currentColor"/>
    </svg>
  `
};
export {
  t as UpliftProtect
};
